<h1 id="title" class="title">Change password</h1>
<p class="sub-title">Please set a new password</p>

<nb-alert *ngIf="errors.length && !submitted" outline="danger" role="alert">
  <p class="alert-title"><b>Oh snap!</b></p>
  <ul>
    <li *ngFor="let e of errors">{{ e }}</li>
  </ul>
</nb-alert>

<nb-alert *ngIf="messages.length && !submitted" outline="success" role="alert">
  <p class="alert-title"><b>Success!</b></p>
  <ul>
    <li *ngFor="let m of messages">{{ m }}</li>
  </ul>
</nb-alert>

<form [formGroup]="resetForm" (ngSubmit)="resetPass()">

  <!-- OTP -->
  <div class="form-control-group">
    <label class="label">OTP Code:</label>
    <input nbInput fullWidth fieldSize="large"
           formControlName="code"
           placeholder="Enter OTP">

    <p class="caption status-danger" *ngIf="f.code.touched && f.code.invalid">
      OTP Code is required!
    </p>
  </div>

  <!-- New Password -->
  <div class="form-control-group">
    <label class="label">New Password:</label>
    <input nbInput fullWidth fieldSize="large"
           type="password"
           formControlName="newPassword"
           placeholder="New Password">

    <p class="caption status-danger" *ngIf="f.newPassword.touched && f.newPassword.invalid">
      Password must be 6–30 characters.
    </p>
  </div>

  <!-- Confirm Password -->
  <div class="form-group">
    <label class="label">Confirm Password:</label>
    <input nbInput fullWidth fieldSize="large"
           type="password"
           formControlName="confirmPassword"
           placeholder="Confirm Password">

    <p class="caption status-danger" *ngIf="f.confirmPassword.touched && f.confirmPassword.invalid">
      Confirm your password!
    </p>

    <p class="caption status-danger"
       *ngIf="resetForm.hasError('passwordMismatch') && f.confirmPassword.touched">
      Password does not match.
    </p>
  </div>

  <button nbButton status="primary" fullWidth size="large"
          [disabled]="submitted || resetForm.invalid">
    Change Password
  </button>
</form>
